// extracted by mini-css-extract-plugin
export var bannerImage = "portfolio-module--bannerImage--433ef";
export var column = "portfolio-module--column--9b4f0";
export var link = "portfolio-module--link--b1a79";
export var list = "portfolio-module--list--550e4";
export var storeButtons = "portfolio-module--storeButtons--3db73";